
export default {
  props: {
    icon: { type: String, default: null },
    label: { type: String, required: true },
    description: { type: String, default: null },
    id: { type: String, default: null },
  },
};
